import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDisputesAPI } from "api/disputesApi";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  disputesList: [],
  meta: {
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
  },
  loading: false,
  error: null,
};

export const getDisputes = createAsyncThunk(
  "dispute/getDisputes",

  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await getDisputesAPI(data);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

const disputeSlice = createSlice({
  name: "dispute",
  initialState,
  reducers: {
    resetDisputesState: (state) => {
      state.disputesList = [];
      state.meta = { total: 0, page: 1, limit: 10, totalPages: 0 };
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getDisputes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDisputes.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.disputesList = payload.data;
        state.meta = payload.meta;
      })
      .addCase(getDisputes.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload || "Failed to load disputes";
      }),
});

export const { resetDisputesState } = disputeSlice.actions;
export default disputeSlice.reducer;
